import React from 'react';
import { TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function VehicleUseSelect(props) {
  const classes = useStyles(); 
  
  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const vehicle_type = states ? states.vehicle_type ? states.vehicle_type : "" : "";
  const vehicle_type_options = states ? states.vehicle_types ? states.vehicle_types.optionFields : [] : [];

  const handleChange = (e, newValue) => {
    dispatch({
      type: ACTIONS.UPDATE_VEHICLE_TYPE,
      payload: newValue
    })
  }

  const renderVehicleTypes = () => {
    if( vehicle_type_options.length ) {
      const models = vehicle_type_options.map((option, key) => {
        return <MenuItem key={`v-type-${ key }`} value={option.label}>
          {option.label}
        </MenuItem>
      })
      return models;
    } else {
      return(
        <MenuItem value="" disabled>
          <em>Select Vehicle Type</em>
        </MenuItem>)
    }
  }

  const clearStates = (statesToClear) => {
    statesToClear.forEach((state) => {
      dispatch({
        type: `UPDATE_${ state.toUpperCase() }`,
        payload: ""
      })
    })
  }

  return(
    <div className={ classes.root }>
      <Autocomplete
        id="autocomplete-car-vehicle-use"
        options={vehicle_type_options}
        getOptionLabel={(option) => option.label ? option.label : ""}
        getOptionSelected={(option, value) => option.label === value.label}
        onChange={handleChange}
        value={ vehicle_type }
        loading={ states.vehicle_type }
        autoSelect={true}
        autoHighlight={true}
        loadingText="Loading..."
        renderInput={(params) => (
          <TextField
            { ...params }
            id="standard-select-vehicle-use"
            name="vehicle_use"
            label="Vehicle Use"
            className={ classes.select }
            InputLabelProps={{
              shrink: true
            }}
          />
        )}
      />
      {/* <TextField
        autoComplete="on"
        id="standard-select-vehicle-type"
        select
        name="vehicle_type"
        label="Vehicle Use"
        value={ vehicle_type }
        className={ classes.select }
        onChange={handleChange}
        InputLabelProps={{
          shrink: true
        }}
      >
        { renderVehicleTypes() }
      </TextField> */}
    </div>
  )
}

export default VehicleUseSelect;